import React from 'react';
import i18n from 'i18n-js';

import Button from '@styles/buttons';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

import TenantStatusLayout from '@components/tenantStatus/common/TenantStatusLayout';
import { useManageDeactivated } from './hooks/useManageDeactivated';

const Deactivated = () => {
  const { onContactUs, onLogOut } = useManageDeactivated();

  return (
    <TenantStatusLayout
      title={i18n.t('Your account has been deactivated')}
      body={i18n.t('Please contact Smart Factory for more information.')}
      onLogOut={onLogOut}
      testID={TEST_IDS.tenantStatus.deactivated.container}
      logOutTestID={TEST_IDS.tenantStatus.deactivated.logOutButton}
      primaryAction={
        <Button
          variant="Dialog M"
          type="Secondary"
          onPress={onContactUs}
          testID={TEST_IDS.tenantStatus.deactivated.contactUsButton}
        >
          {i18n.t('Contact us')}
        </Button>
      }
    />
  );
};

export default Deactivated;
